import { RoutingLink } from "#src/batteries-included-components/RoutingLink";
import { WorkflowDetailsRoutePath } from "#src/routes/workflows/all/[workflowId]/detail";
import { RichTextMarkdownDataDisplay } from "@validereinc/common-components";
import type { ExecuteWorkflowToolResultMetadataType } from "@validereinc/domain";
import classNames from "classnames/bind";
import React from "react";
import styles from "./InvestigationDetailPage.module.scss";

const cx = classNames.bind(styles);

type ExecuteWorkflowTerminalMessageContentProps = {
  content: string;
  toolResultMetadata: ExecuteWorkflowToolResultMetadataType;
};

/**
 * Agent message after workflow terminal EventBridge handling (complete / failed).
 */
export const ExecuteWorkflowTerminalMessageContent = ({
  content,
  toolResultMetadata,
}: ExecuteWorkflowTerminalMessageContentProps) => {
  const workflowId = toolResultMetadata.result.workflow_id;

  return (
    <div className={cx("conversation-feed__execute-workflow-terminal")}>
      <RichTextMarkdownDataDisplay
        value={content}
        isInline={false}
        isContainerSizing
        isConstrainedToParentWidth
        className={cx("conversation-feed__bubble__body")}
        markdownContainerClassName={cx("conversation-feed__bubble__markdown")}
      />
      <div className={cx("conversation-feed__execute-workflow-terminal__link")}>
        <RoutingLink
          to={WorkflowDetailsRoutePath.toLinkParts({
            pathParams: { workflowId },
          })}
        >
          View workflow
        </RoutingLink>
      </div>
    </div>
  );
};
